<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread" v-if="type == 11">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamelist' }">{{ "竞技赛事" }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamedetail', params: { gameId: gameId } }">{{ "赛事详情" }}</router-link>
          <span>></span>
          <span>{{ "支付报名费" }}</span>
        </div>
        <div class="nav-bread" v-if="type == 10">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <span>{{ "支付报名费" }}</span>
        </div>
      </div>
    </div>
    <div class="main shop-container">
      <div class="count-title bgw">
        <div class="l">
          <div class="head">{{ $t("project") }}：</div>
          <div class="item-list">
            <div class="item-li">{{ title }}</div>
          </div>
        </div>
        <div class="total">
          {{ this.$t("currencySymbol") }}
          <span class="total-money">{{ orderInfo.money }}</span>
        </div>
      </div>
      <div class="pay-box bgw">
        <div class="title">{{ $t("payment") }}</div>
        <div class="box-info">
          <el-radio-group v-model="payType">
            <el-radio :label="item.code" v-for="(item, index) in payments" :key="index">
              <span class="pay-type" :class="{ active: payType == item.code }">
                <i class="icon iconfont iconxianxiamendian" v-if="item.code == 'offline'"></i>
                <i class="icon iconfont iconyuezhifu" v-else-if="item.code == 'balancepay'"></i>
                <i class="icon iconfont iconzhifubao" v-else-if="item.code == 'alipay'"></i>
                <i class="icon iconfont iconweixinzhifu" v-else-if="item.code == 'wechatpay'"></i>
                {{ item.name }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="pay-block">
          <div class="pay-info">
            {{ this.$t("currencySymbol") }}
            <span class="total-money">{{ orderInfo.money }}</span>
          </div>
        </div>
        <div class="pay-block">
          <el-button class="pay-btn" :loading="btnLoading" @click="toPay">{{ "去付款" }}</el-button>
        </div>
      </div>
    </div>
    <template v-if="dialogPaymentShow">
      <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
    </template>
  </div>
</template>

<script>
import Payment from "@/components/payment.vue";
import { locationHost } from "@/config/env.js";
export default {
  name: "gamePay",
  components: { Payment },
  props: {},
  data() {
    return {
      title: "",
      payments: [],
      payType: "alipay",
      orderInfo: {},
      code_url: "",
      dialogPaymentShow: false,
      intervalPayStatus: "",
      remainingTime: "",
      hour: "",
      minute: "",
      second: "",
      promiseTimer: "",
      btnLoading: false, // 禁用btn
      type: "",
      project_id: "",
      bk:false
    };
  },
  watch: {},
  computed: {
    hourString() {
      return this.formatNum(this.hour);
    },
    minuteString() {
      return this.formatNum(this.minute);
    },
    secondString() {
      return this.formatNum(this.second);
    },
  },
  methods: {
    toPay() {
      this.btnLoading = true;
      let code = this.payType;
      if (code == "wechatpay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: this.type,
          params: {
            trade_type: "NATIVE",
          },
        };
        // 微信h5支付
        this.$api
          .pay(data)
          .then((res) => {
            this.btnLoading = false;
            if (res.status) {
              this.dialogPaymentShow = true;
              this.code_url = res.data.code_url;
              this.getPaymentStatus(res.data.payment_id);
            } else {
              this.$msg(res.msg, "error");
            }
          })
          .catch(() => {
            this.btnLoading = false;
          });
      } else if (code == "alipay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: this.type,
          params: {
            trade_type: "PC",
            return_url: this.type==10 ? locationHost + "/#/enroll/" + JSON.parse(sessionStorage.getItem('nowPageData')) : locationHost + "/#/gamedetail/" + this.project_id,
          },
        };
        this.$api
          .pay(data)
          .then((res) => {
            this.btnLoading = false;
            if (res.status) {
              this.standarPost(res.data.url, res.data.data);
            }
          })
          .catch(() => {
            this.btnLoading = false;
          });
      } else if (code == "balancepay") {
        let data = {
          ids: this.order_id,
          payment_code: code,
          payment_type: this.type,
        };
        this.$api
          .pay(data)
          .then((res) => {
            this.btnLoading = false;
            if (res.status && res.msg == this.$t("paySucess")) {
              this.$msg(this.$t("paySucess"));
              this.toPaySuccess();
            } else {
              this.$msg(res.msg, "warning");
            }
          })
          .catch(() => {
            this.btnLoading = false;
          });
      } else if (code == "offline") {
        this.$confirm(this.$t("paymentofflineTitle"), this.$t("offlineExplain"), {
          confirmButtonText: this.$t("orderDetail"),
          cancelButtonText: this.$t("next"),
          type: "info",
        })
          .then(() => {
            this.btnLoading = false;
            this.$router.replace({
              name: "orderDetail",
              params: { order_id: this.order_id },
            });
          })
          .catch(() => {
            this.btnLoading = false;
            this.$router.replace({ name: "home" });
          });
      }
    },
    standarPost(url, data) {
      let tempForm = document.createElement("form");
      tempForm.id = "aliPay";
      tempForm.methods = "post";
      tempForm.action = url;
      tempForm.target = "_self";
      let input = [];
      for (let k in data) {
        input[k] = document.createElement("input");
        input[k].type = "hidden";
        input[k].name = k;
        input[k].value = data[k];
        tempForm.appendChild(input[k]);
      }
      tempForm.addEventListener("submit", function () {}, false);
      document.body.appendChild(tempForm);
      tempForm.dispatchEvent(new Event("submit"));
      tempForm.submit();
      document.body.removeChild(tempForm);
    },
    clearInterPay() {
      clearInterval(this.intervalPayStatus);
      this.dialogPaymentShow = false;
    },
    toPaySuccess() {
      if (this.type == 11) {
        this.$router.replace({
          name: "paySuccess",
          query: { order_id: this.order_id, enroll: true },
        });
      } else if (this.type == 10) {
        // if(this.bk){
          this.$router.replace({
          name: "enroll",
          params: { id: JSON.parse(sessionStorage.getItem('nowPageData'))  },
        });
        // }else{
        //   this.$router.replace({
        //   name: "paySuccess",
        //   query: { order_id: this.order_id, exam: true },
        // });
        // }
       
      }
    },
    getPaymentStatus(id) {
      let data = {
        payment_id: id,
      };
      let that = this;
      this.intervalPayStatus = setInterval(function () {
        that.$api.paymentInfo(data).then((res) => {
          if (res.status) {
            if (res.data.status == 2) {
              that.$msg(that.$t("paySucess"));
              that.toPaySuccess();
            }
          }
        });
      }, 1000);
    },
    // 支付方式
    getPaymentType() {
      this.$api.paymentList().then((res) => {
        let data = res.data;
        this.payments = data;
      });
    },
    // 获取订单详情
    getOrderInfo() {
      let data = {
        ids: this.order_id,
        payment_type: this.type,
      };
      this.$api.paymentsCheckpay(data).then((res) => {
        if (res.status) {
          this.orderInfo = res.data.rel[0];
        } else {
          this.$common.errorToShow(res.msg);
        }
      });
    },
    // 原本的订单详情
    getOrderDetail() {
      let data = {
        order_id: this.order_id,
      };
      this.$api.orderDetail(data).then((res) => {
        if (res.status) {
          this.orderInfo = res.data;
          console.dir(res.data);
          let remainingTime = res.data.remaining_time;
          this.remainingTime = remainingTime;
          console.log(this.remainingTime);
          this.getCountDownTime(remainingTime);
          if (res.data.pay_status == 2) {
            this.toPaySuccess();
          }
        }
      });
    },
    getCountDownTime(time) {
      if (Number(time) > 0) {
        this.hour = Math.floor(time / 3600);
        this.minute = Math.floor((time / 60) % 60);
        this.second = Math.floor(time % 60);
        this.countDown();
      }
    },
    countDown() {
      let that = this;
      clearInterval(this.promiseTimer);
      this.promiseTimer = setInterval(function () {
        if (that.hour === 0) {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59;
            that.minute -= 1;
          } else if (that.minute === 0 && that.second === 0) {
            that.second = 0;
            clearInterval(that.promiseTimer);
          } else {
            that.second -= 1;
          }
        } else {
          if (that.minute !== 0 && that.second === 0) {
            that.second = 59;
            that.minute -= 1;
          } else if (that.minute === 0 && that.second === 0) {
            that.hour -= 1;
            that.minute = 59;
            that.second = 59;
          } else {
            that.second -= 1;
          }
        }
      }, 1000);
    },
    formatNum(num) {
      return num < 10 ? "0" + num : " " + num;
    },
  },
  created() {},
  mounted() {
    let orderId = this.$route.params.order_id;
    this.type = this.$route.params.type;
    this.title = this.$route.params.title;
    this.bk = this.$route.params.bk
    this.project_id = this.$route.params.project_id;
    this.order_id = orderId;
    this.getPaymentType();
    this.getOrderInfo();
  },
  destroyed() {
    clearInterval(this.promiseTimer);
    clearInterval(this.intervalPayStatus);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.wrapper {
  .main {
    .timetip {
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 16px auto;
      color: #757575;
      .icon {
        color: #757575;
        margin-right: 5px;
      }
    }
    .count-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 14px;
      margin-bottom: 10px;
      .l {
        display: inline-flex;
        .head {
          width: 60px;
          height: 30px;
          line-height: 30px;
        }
        .item-list {
          .item-li {
            height: 30px;
            line-height: 30px;
          }
        }
      }
      .total {
        color: $theme-color;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        &-money {
          font-size: 24px;
        }
      }
    }
    .pay-box {
      padding: 14px;
      margin-bottom: 20px;
      .title {
        margin-bottom: 20px;
      }
      .box-info {
        display: flex;
        margin-bottom: 40px;
        .pay-type {
          display: inline-block;
          width: 130px;
          height: 36px;
          line-height: 32px;
          text-align: center;
          border: 1px solid $border;
          transition: all 0.2s;
          cursor: pointer;
          padding: 1px;
          box-sizing: border-box;
          &.active,
          &:hover {
            border-color: $theme-color;
          }
        }
      }
      .pay-block {
        height: 50px;
        .pay-info {
          float: right;
          color: $theme-color;
          .total-money {
            font-size: 24px;
          }
        }
        .pay-btn {
          float: right;
          // width: 90px;
          // height: 32px;
          line-height: 6px;
          border-radius: 16px;
          text-align: center;
          background: $theme-color;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .t {
    border-bottom: 2px solid $theme-color;
    height: 100px;
    .shop-container {
      padding-top: 30px;
      .logo-icon {
        float: left;
        width: 48px;
        height: 48px;
        margin-right: 10px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .logo-text {
        float: left;
        margin-top: 0px;
        font-size: 20px;
        color: #424242;
        line-height: 48px;
        margin-right: 20px;
      }
      .tip {
        float: left;
        line-height: 20px;
        margin-top: 20px;
        font-size: 12px;
        color: #757575;
      }
      .group {
        float: right;
        margin-top: 20px;
        display: flex;
        color: #757575;
        font-size: 12px;
        .item {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }
        .line {
          height: 20px;
          line-height: 20px;
          color: #757575;
          margin-top: 10px;
          margin: 10px 10px 0;
        }
      }
    }
  }
}
</style>
